export default function ProjectSpecs( { data } ){
    const summary = data?.properties?.Summary?.rich_text[0]?.plain_text || '';
    const date = data?.properties?.Date?.rich_text[0]?.plain_text || '';
    const role = data?.properties?.Role?.rich_text[0]?.plain_text || '';
    const impact = data?.properties?.Impact?.rich_text[0]?.plain_text || '';
    const stack = data?.properties?.Stack?.rich_text[0]?.plain_text || '';
    const url = data?.properties?.URL?.rich_text[0]?.plain_text || '';

    return(
        <div className = "projectSpecs">
                { summary && (
                <table>
                    <tbody>
                        <tr>
                            <th>Summary</th>
                            <td><pre>{ summary }</pre></td>
                        </tr>
                    </tbody>
                </table>
                )}

                {impact && (
                <table style = { { borderTop : "1px solid var(--black8)" } }>
                    <tbody>
                            <tr>
                                <th>Impact</th>
                                <td><pre>{ impact }</pre></td>
                            </tr>
                    </tbody>
                </table>
                )}

                {date && (
                <table style = { { borderTop : "1px solid var(--black8)" } }>
                    <tbody>
                            <tr>
                                <th>Date</th>
                                <td><pre>{ date }</pre></td>
                            </tr>
                    </tbody>
                </table>
                )}

                {role && (
                <table style = { { borderTop : "1px solid var(--black8)" } }>
                    <tbody>
                        
                        <tr>
                            <th>Role</th>
                            <td><pre>{ role }</pre></td>
                        </tr>
                    
                        <tr>
                            <th>Category</th>
                            <td>{ data?.properties?.Category?.multi_select.map( item => item.name ).join(", ") }</td>
                        </tr>
                    
                        <tr>
                            <th>Stack</th>
                            <td><pre>{ stack }</pre></td>
                        </tr>
                        
                    </tbody>
                </table>
                )}

                {url && (
                <table style = { { borderTop : "1px solid var(--black8)" } }>
                    <tbody>
                            <tr>
                                <th>Link</th>
                                <td><pre><a className = "a" href={ url } target="_blank" rel="noopener noreferrer">{ url }</a></pre></td>
                            </tr>
                        
                    </tbody>
                </table>
                )}

        </div>
    )
}